<script>
import { addNav } from '@/mixins';

export default {
  name: 'YhMenu',
  props: {
    menuData: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [addNav],
  data() {
    return {
      // url 和 名称分隔符
      splitor: '$_s_$',
    };
  },
  methods: {
    renderMenu(list) {
      if (!list) {
        return null;
      }
      return list.map((item) => {
        if (item.children) {
          return <el-submenu index={`${item.id}`} key={`${item.id}`}>
          <template slot="title">{item.menuName}</template>
          {this.renderMenu(item.children)}
        </el-submenu>;
        }
        return <el-menu-item index={`${item.menuName}${this.splitor}${item.routerUrl || ''}`}>{item.menuName}</el-menu-item>;
      });
    },
    navigate(index) {
      const [menuName, menuUrl] = index.split(this.splitor);
      if (!menuName || !menuUrl) {
        return;
      }
      this.addNav({
        path: menuUrl,
        name: menuName,
        query: '',
      });
    },
  },
  // eslint-disable-next-line no-unused-vars
  render(h) {
    return (
      <el-menu mode="horizontal" onSelect={this.navigate.bind(this)}>
        {this.renderMenu(this.menuData)}
      </el-menu>
    );
  },
};
</script>
